var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mode-free-skills"},[_c('PrimarySkills',{ref:"primarySkills",attrs:{"initPrimarySkills":_vm.initPrimarySkills}}),_c('SecondarySkills',{ref:"secondarySkills",attrs:{"initSecondarySkills":_vm.initSecondarySkills}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }